import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HeroSection = ({ organizationName, organizationLogo, onSSOLogin }) => {
  const navigate = useNavigate();

  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-16 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex items-center justify-center mb-8">
          <div className="bg-card rounded-2xl shadow-lg p-6 border border-border">
            <Image
              src={organizationLogo}
              alt={`${organizationName} company logo featuring modern design with primary brand colors`}
              className="h-20 w-auto object-contain"
            />
          </div>
        </div>

        <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-4">
          Welcome to {organizationName} Early Intervention 
        </h1>
        
        <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
          Connect with lived-experience volunteers and licensed professionals who understand your journey. Access confidential support in minutes, not weeks.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Button
            variant="default"
            size="lg"
            iconName="LogIn"
            iconPosition="right"
            onClick={onSSOLogin}
            className="min-w-[240px]"
          >
            Sign In with SSO
          </Button>
          
          <Button
            variant="secondary"
            size="lg"
            iconName="UserCircle"
            iconPosition="right"
            onClick={() => navigate('/signin')}
            className="min-w-[240px]"
          >
            Sign In with Public OAuth
          </Button>
          
          <Button
            variant="outline"
            size="lg"
            iconName="Phone"
            iconPosition="left"
            onClick={() => window.location.href = '#crisis-resources'}
            className="min-w-[240px]"
          >
            Crisis Resources
          </Button>
        </div>

        <p className="text-sm text-muted-foreground">
          Secure authentication powered by your organization's identity provider
        </p>
      </div>
    </section>
  );
};

export default HeroSection;